import { render, staticRenderFns } from "./termsFormWithComponents.vue?vue&type=template&id=c9a75f48&"
import script from "./termsFormWithComponents.vue?vue&type=script&lang=js&"
export * from "./termsFormWithComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports